import { FileText } from "lucide-react";

interface SourceListWidgetProps {
  sources: Array<{
    pageId: string;
    slug: string;
    title: string;
    snippet: string;
    relevanceScore: number;
  }>;
  onSourceClick?: (source: { pageId: string; title: string; slug: string }) => void;
}

export function SourceListWidget({ sources, onSourceClick }: SourceListWidgetProps) {
  return (
    <div className="space-y-1">
      {sources.map((source) => (
        <button
          type="button"
          key={source.pageId}
          className="w-full text-left flex items-start gap-2 text-xs p-2 rounded bg-muted/50 hover:bg-accent hover:text-accent-foreground transition-colors cursor-pointer border border-transparent hover:border-primary/20"
          onClick={() => onSourceClick?.(source)}
        >
          <FileText className="h-3 w-3 mt-0.5 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="font-medium truncate hover:underline text-primary">{source.title}</div>
            {source.snippet && (
              <div className="text-muted-foreground line-clamp-2 mt-0.5">{source.snippet}</div>
            )}
          </div>
        </button>
      ))}
    </div>
  );
}
